import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Calendar } from 'src/app/shared/helpers/calendar';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Education } from '../../../shared/models/education';
import { CandidateStore } from 'src/app/dashboards/store/candidate-store';
import { AppStore } from '../../../shared/store/lookup-store.service';

@Component({
  selector: 'app-education-form',
  templateUrl: './education-form.component.html',
  styleUrls: ['./education-form.component.scss']
})
export class EducationFormComponent implements OnInit {
  @Input() education: Education;
  @Input() index: number;
  @Input() collapse_education: boolean;
  @Output() saved: EventEmitter<any> = new EventEmitter();

  years: number[];
  form: FormGroup;
  buttonText: string = "Add";

  constructor(private formBuilder: FormBuilder, private dashboardState: CandidateStore, public lookupStore: AppStore) {
    const currentYear = new Date().getFullYear();

    this.form = this.formBuilder.group({
      educationLevel: [''],
      subject: [''],
      year: [`${currentYear}`],
      institute: [''],
      description: ['']
    });
  }

  ngOnInit() {
    this.years = Calendar.getPastYears(50);

    if (this.education) {
      this.buttonText = "Save";
      this.form.patchValue({ "educationLevel": this.education.educationLevelId });
      this.form.patchValue({ "subject": this.education.subject });
      this.form.patchValue({ "year": this.education.year });
      this.form.patchValue({ "institute": this.education.institute });
      this.form.patchValue({ "description": this.education.description });
    }
  }

  save(): void {
    if (!this.form.valid) {
      return;
    }

    let education = Education.parseForm(this.form);
    education.educationLevel = this.lookupStore.getEducationLevel(education.educationLevelId).value;
    if (!this.education) {
      this.dashboardState.addEducation(education);
      this.form.reset();
      this.saved.emit();
      return;
    }

    this.dashboardState.updateEducation(education, this.index);
    this.saved.emit();
  }

}
